(() => {
  const root = document.querySelector('[data-monolith-advisors]');
  const host = root?.querySelector('[data-advisor-order-requests]');
  if (!host) return;
  const translations = {
  "de": [
    "Bitte auswählen",
    "Was möchtest du anfragen?",
    "Adresse korrigieren",
    "Artikel ergänzen",
    "Stornierung anfragen",
    "Neue vollständige Lieferadresse",
    "Gewünschter Artikel, Variante und Menge",
    "Weitere Angaben zur Stornierungsanfrage (optional)",
    "Angaben zur Zahlung",
    "Zahlungsart",
    "Andere Zahlungsart",
    "Beim Kauf verwendete E-Mail-Adresse",
    "Datum der Zahlung (falls bekannt)",
    "Betrag und Währung (falls bekannt)",
    "Bestellbestätigung erhalten?",
    "Ja",
    "Nein",
    "Unsicher",
    "Prüfe bitte auch Spamordner und dein Kundenkonto. Teile uns mit, ob die Zahlung als abgeschlossen oder nur als vorgemerkt angezeigt wird. Bitte keine Passwörter, Karten- oder Kontodaten senden.",
    "Änderungsanfrage",
    "Angaben zur Zahlung"
  ],
  "en": [
    "Please choose",
    "What would you like to request?",
    "Correct address",
    "Add an item",
    "Request cancellation",
    "New full delivery address",
    "Requested item, variant and quantity",
    "More about the cancellation request (optional)",
    "Payment information",
    "Payment method",
    "Other payment method",
    "Email address used at checkout",
    "Payment date (if known)",
    "Amount and currency (if known)",
    "Order confirmation received?",
    "Yes",
    "No",
    "Not sure",
    "Please check your spam folder and customer account too. Tell us whether the payment appears completed or only pending. Do not send passwords, card or bank account details.",
    "Change request",
    "Payment information"
  ],
  "fr": [
    "Veuillez choisir",
    "Que souhaitez-vous demander ?",
    "Corriger l’adresse",
    "Ajouter un article",
    "Demander une annulation",
    "Nouvelle adresse de livraison complète",
    "Article souhaité, variante et quantité",
    "Précisions sur l’annulation (facultatif)",
    "Informations sur le paiement",
    "Moyen de paiement",
    "Autre moyen de paiement",
    "Adresse e-mail utilisée à l’achat",
    "Date du paiement (si connue)",
    "Montant et devise (si connus)",
    "Confirmation de commande reçue ?",
    "Oui",
    "Non",
    "Je ne sais pas",
    "Vérifiez aussi les spams et votre compte client. Indiquez si le paiement est finalisé ou seulement en attente. N’envoyez aucun mot de passe ni coordonnées de carte ou bancaires.",
    "Demande de modification",
    "Informations sur le paiement"
  ],
  "it": [
    "Seleziona",
    "Cosa vuoi richiedere?",
    "Correggere l’indirizzo",
    "Aggiungere un articolo",
    "Richiedere l’annullamento",
    "Nuovo indirizzo di consegna completo",
    "Articolo desiderato, variante e quantità",
    "Dettagli sull’annullamento (facoltativo)",
    "Informazioni sul pagamento",
    "Metodo di pagamento",
    "Altro metodo di pagamento",
    "Email usata per l’acquisto",
    "Data del pagamento (se nota)",
    "Importo e valuta (se noti)",
    "Hai ricevuto la conferma d’ordine?",
    "Sì",
    "No",
    "Non so",
    "Controlla anche lo spam e il tuo account cliente. Indica se il pagamento risulta completato o solo in sospeso. Non inviare password, dati della carta o del conto bancario.",
    "Richiesta di modifica",
    "Informazioni sul pagamento"
  ],
  "es": [
    "Selecciona",
    "¿Qué quieres solicitar?",
    "Corregir la dirección",
    "Añadir un artículo",
    "Solicitar cancelación",
    "Nueva dirección de entrega completa",
    "Artículo deseado, variante y cantidad",
    "Detalles de la cancelación (opcional)",
    "Datos del pago",
    "Método de pago",
    "Otro método de pago",
    "Correo usado en la compra",
    "Fecha del pago (si la sabes)",
    "Importe y moneda (si los sabes)",
    "¿Recibiste confirmación del pedido?",
    "Sí",
    "No",
    "No estoy seguro/a",
    "Revisa también el spam y tu cuenta de cliente. Indica si el pago aparece completado o solo pendiente. No envíes contraseñas ni datos de tarjeta o cuenta bancaria.",
    "Solicitud de modificación",
    "Datos del pago"
  ],
  "pl": [
    "Wybierz",
    "O co chcesz poprosić?",
    "Poprawić adres",
    "Dodać produkt",
    "Poprosić o anulowanie",
    "Nowy pełny adres dostawy",
    "Żądany produkt, wariant i ilość",
    "Szczegóły anulowania (opcjonalnie)",
    "Informacje o płatności",
    "Metoda płatności",
    "Inna metoda płatności",
    "E-mail użyty przy zakupie",
    "Data płatności (jeśli znana)",
    "Kwota i waluta (jeśli znane)",
    "Otrzymano potwierdzenie zamówienia?",
    "Tak",
    "Nie",
    "Nie wiem",
    "Sprawdź także spam i konto klienta. Napisz, czy płatność jest zakończona czy tylko oczekująca. Nie wysyłaj haseł ani danych karty lub rachunku bankowego.",
    "Prośba o zmianę",
    "Informacje o płatności"
  ],
  "sv": [
    "Välj",
    "Vad vill du be om?",
    "Rätta adress",
    "Lägga till en vara",
    "Begära avbokning",
    "Ny fullständig leveransadress",
    "Önskad vara, variant och antal",
    "Mer om avbokningen (valfritt)",
    "Betalningsinformation",
    "Betalningssätt",
    "Annat betalningssätt",
    "E-postadress som användes vid köpet",
    "Betalningsdatum (om känt)",
    "Belopp och valuta (om känt)",
    "Har du fått orderbekräftelse?",
    "Ja",
    "Nej",
    "Osäker",
    "Kontrollera även skräpposten och ditt kundkonto. Berätta om betalningen visas som slutförd eller bara reserverad. Skicka inga lösenord, kort- eller bankkontouppgifter.",
    "Ändringsförfrågan",
    "Betalningsinformation"
  ],
  "fi": [
    "Valitse",
    "Mitä haluat pyytää?",
    "Korjaa osoite",
    "Lisää tuote",
    "Pyydä peruutusta",
    "Uusi täydellinen toimitusosoite",
    "Haluttu tuote, vaihtoehto ja määrä",
    "Lisätietoa peruutuspyynnöstä (valinnainen)",
    "Maksutiedot",
    "Maksutapa",
    "Muu maksutapa",
    "Ostossa käytetty sähköpostiosoite",
    "Maksupäivä (jos tiedossa)",
    "Summa ja valuutta (jos tiedossa)",
    "Saitko tilausvahvistuksen?",
    "Kyllä",
    "En",
    "En tiedä",
    "Tarkista myös roskaposti ja asiakastilisi. Kerro, näkyykö maksu valmiina vai vasta katevarauksena. Älä lähetä salasanoja, kortti- tai pankkitilitietoja.",
    "Muutospyyntö",
    "Maksutiedot"
  ],
  "nl": [
    "Kies",
    "Wat wil je aanvragen?",
    "Adres corrigeren",
    "Artikel toevoegen",
    "Annulering aanvragen",
    "Nieuw volledig afleveradres",
    "Gewenst artikel, variant en aantal",
    "Meer over de annulering (optioneel)",
    "Betaalinformatie",
    "Betaalmethode",
    "Andere betaalmethode",
    "E-mailadres gebruikt bij aankoop",
    "Betaaldatum (indien bekend)",
    "Bedrag en valuta (indien bekend)",
    "Bestelbevestiging ontvangen?",
    "Ja",
    "Nee",
    "Weet ik niet",
    "Controleer ook je spammap en klantaccount. Geef aan of de betaling voltooid of alleen gereserveerd is. Stuur geen wachtwoorden, kaart- of bankrekeninggegevens.",
    "Wijzigingsverzoek",
    "Betaalinformatie"
  ]
};
  const locale = root.dataset.locale?.split('-')[0];
  const t = translations[locale] || translations.en;
  const transfers = {de:'Vorkasse / Überweisung',en:'Bank transfer',fr:'Virement bancaire',it:'Bonifico bancario',es:'Transferencia bancaria',pl:'Przelew bankowy',sv:'Banköverföring',fi:'Pankkisiirto',nl:'Bankoverschrijving'};
  const groups = {};
  const group = (key, title) => {
    const fieldset = document.createElement('fieldset');
    fieldset.dataset.advisorRequestGroup = key;
    fieldset.hidden = true;
    fieldset.disabled = true;
    const legend = document.createElement('legend');
    legend.textContent = title;
    fieldset.append(legend);
    host.append(fieldset);
    groups[key] = fieldset;
    return fieldset;
  };
  const field = (parent, key, title, type, name, options) => {
    const label = document.createElement('label');
    const input = document.createElement(type === 'select' ? 'select' : type === 'textarea' ? 'textarea' : 'input');
    input.id = 'monolith-request-' + key;
    input.name = 'contact[' + name + ']';
    label.htmlFor = input.id;
    label.textContent = title;
    if (type === 'select') {
      for (const [value, text] of [['', t[0]], ...options]) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = text;
        input.append(option);
      }
      input.required = true;
    } else if (type === 'textarea') { input.rows = 3; input.maxLength = 1500; }
    else { input.type = type; input.maxLength = 150; }
    parent.append(label, input);
    return input;
  };
  const change = group('change', t[19]);
  const kind = field(change, 'kind', t[1], 'select', 'Aenderungswunsch', [['address',t[2]],['add',t[3]],['cancel',t[4]]]);
  const changeDetails = field(change, 'details', t[5], 'textarea', 'Gewuenschte Aenderung');
  const detailsLabel = change.querySelector('label[for="monolith-request-details"]');
  const updateChange = () => {
    detailsLabel.textContent = t[kind.value === 'add' ? 6 : kind.value === 'cancel' ? 7 : 5];
    changeDetails.required = kind.value === 'address' || kind.value === 'add';
    detailsLabel.hidden = !kind.value;
    changeDetails.hidden = !kind.value;
    changeDetails.disabled = !kind.value;
  };
  kind.addEventListener('change', () => { changeDetails.value = ''; updateChange(); });
  updateChange();
  const payment = group('payment', t[20]);
  field(payment, 'method', t[9], 'select', 'Zahlungsart', [['PayPal','PayPal'],['Vorkasse',transfers[locale] || transfers.en],['Klarna','Klarna'],['other',t[10]]]);
  const email = field(payment, 'checkout-email', t[11], 'email', 'E-Mail beim Kauf');
  email.autocomplete = 'email';
  email.required = true;
  field(payment, 'date', t[12], 'date', 'Zahlungsdatum');
  field(payment, 'amount', t[13], 'text', 'Betrag und Waehrung');
  field(payment, 'confirmation', t[14], 'select', 'Bestellbestaetigung erhalten', [['yes',t[15]],['no',t[16]],['unsure',t[17]]]);
  const hint = document.createElement('p');
  hint.className = 'mono-advisors__note';
  hint.textContent = t[18];
  payment.append(hint);
  const missingCopy = {
  "de": [
    "Artikel fehlt / Teillieferung",
    "Fehlt etwas oder kommt es separat?",
    "Prüfe, ob es weitere Versandmails oder Trackingnummern für dieselbe Bestellung gibt.",
    "Vergleiche Bestellbestätigung, Packzettel und erhaltene Artikel.",
    "Eine separate Lieferung können wir erst nach Prüfung bestätigen. Nenne unten den fehlenden Artikel mit Variante und Menge; wir prüfen den tatsächlichen Stand.",
    "Weitere Versandmail oder Trackingnummer gefunden?",
    "Ja",
    "Nein",
    "Noch nicht geprüft",
    "Packzettel mit der Bestellung verglichen?",
    "Ja",
    "Nein",
    "Kein Packzettel vorhanden",
    "Weitere Trackingnummer (falls bekannt)"
  ],
  "en": [
    "Missing item / split delivery",
    "Missing or coming separately?",
    "Check for more dispatch emails or tracking numbers for the same order.",
    "Compare the order confirmation, packing slip and received items.",
    "We can only confirm a separate delivery after checking. Tell us the missing item, variant and quantity below; we will check the actual status.",
    "Found another dispatch email or tracking number?",
    "Yes",
    "No",
    "Not checked yet",
    "Compared the packing slip with the order?",
    "Yes",
    "No",
    "No packing slip included",
    "Other tracking number (if known)"
  ],
  "fr": [
    "Article manquant / envoi séparé",
    "Manquant ou envoyé séparément ?",
    "Vérifiez les autres e-mails d’expédition ou numéros de suivi de cette commande.",
    "Comparez la confirmation, le bon de livraison et les articles reçus.",
    "Un envoi séparé doit être vérifié avant confirmation. Indiquez l’article manquant, sa variante et sa quantité ; nous vérifierons la situation.",
    "Autre e-mail d’expédition ou suivi trouvé ?",
    "Oui",
    "Non",
    "Pas encore vérifié",
    "Bon de livraison comparé à la commande ?",
    "Oui",
    "Non",
    "Pas de bon de livraison",
    "Autre numéro de suivi (si connu)"
  ],
  "it": [
    "Articolo mancante / invio separato",
    "Manca o arriva separatamente?",
    "Controlla altre email di spedizione o numeri di tracking dello stesso ordine.",
    "Confronta conferma d’ordine, documento nel pacco e articoli ricevuti.",
    "Possiamo confermare un invio separato solo dopo verifica. Indica articolo mancante, variante e quantità; controlleremo la situazione.",
    "Hai trovato un’altra email o un altro tracking?",
    "Sì",
    "No",
    "Non ancora controllato",
    "Hai confrontato il documento nel pacco con l’ordine?",
    "Sì",
    "No",
    "Nessun documento nel pacco",
    "Altro numero di tracking (se noto)"
  ],
  "es": [
    "Artículo faltante / envío separado",
    "¿Falta o llega por separado?",
    "Busca otros correos de envío o números de seguimiento del mismo pedido.",
    "Compara la confirmación, el albarán y los artículos recibidos.",
    "Solo podemos confirmar un envío separado tras comprobarlo. Indica el artículo que falta, variante y cantidad; revisaremos el estado real.",
    "¿Encontraste otro correo de envío o seguimiento?",
    "Sí",
    "No",
    "Aún no lo he revisado",
    "¿Comparaste el albarán con el pedido?",
    "Sí",
    "No",
    "No había albarán",
    "Otro número de seguimiento (si lo sabes)"
  ],
  "pl": [
    "Brak produktu / osobna przesyłka",
    "Brakuje czy przyjdzie osobno?",
    "Sprawdź inne e-maile o wysyłce lub numery śledzenia tego samego zamówienia.",
    "Porównaj potwierdzenie zamówienia, kartę pakowania i otrzymane produkty.",
    "Osobną dostawę potwierdzimy dopiero po sprawdzeniu. Podaj brakujący produkt, wariant i ilość; sprawdzimy rzeczywisty stan.",
    "Znaleziono inny e-mail o wysyłce lub numer śledzenia?",
    "Tak",
    "Nie",
    "Jeszcze nie sprawdzono",
    "Porównano kartę pakowania z zamówieniem?",
    "Tak",
    "Nie",
    "Brak karty pakowania",
    "Inny numer śledzenia (jeśli znany)"
  ],
  "sv": [
    "Saknad vara / separat leverans",
    "Saknas eller kommer separat?",
    "Kontrollera fler leveransmejl eller spårningsnummer för samma beställning.",
    "Jämför orderbekräftelsen, packsedeln och mottagna varor.",
    "Vi kan bara bekräfta en separat leverans efter kontroll. Ange saknad vara, variant och antal nedan så granskar vi läget.",
    "Hittat ett till leveransmejl eller spårningsnummer?",
    "Ja",
    "Nej",
    "Inte kontrollerat än",
    "Jämfört packsedeln med beställningen?",
    "Ja",
    "Nej",
    "Ingen packsedel medföljde",
    "Annat spårningsnummer (om känt)"
  ],
  "fi": [
    "Puuttuva tuote / erillinen lähetys",
    "Puuttuuko vai tuleeko erikseen?",
    "Tarkista saman tilauksen muut lähetysviestit tai seurantanumerot.",
    "Vertaa tilausvahvistusta, pakkauslistaa ja saatuja tuotteita.",
    "Voimme vahvistaa erillisen toimituksen vasta tarkistuksen jälkeen. Kerro puuttuva tuote, vaihtoehto ja määrä, niin selvitämme tilanteen.",
    "Löytyikö toinen lähetysviesti tai seurantanumero?",
    "Kyllä",
    "Ei",
    "En ole vielä tarkistanut",
    "Vertasitko pakkauslistaa tilaukseen?",
    "Kyllä",
    "En",
    "Pakkauslistaa ei ollut",
    "Toinen seurantanumero (jos tiedossa)"
  ],
  "nl": [
    "Artikel ontbreekt / deelzending",
    "Ontbreekt het of komt het apart?",
    "Controleer andere verzendmails of trackingnummers van dezelfde bestelling.",
    "Vergelijk de bestelbevestiging, pakbon en ontvangen artikelen.",
    "Een aparte levering bevestigen we pas na controle. Geef het ontbrekende artikel, de variant en het aantal door; we controleren de werkelijke status.",
    "Andere verzendmail of tracking gevonden?",
    "Ja",
    "Nee",
    "Nog niet gecontroleerd",
    "Pakbon met bestelling vergeleken?",
    "Ja",
    "Nee",
    "Geen pakbon aanwezig",
    "Ander trackingnummer (indien bekend)"
  ]
};
  const missingText = missingCopy[locale] || missingCopy.en;
  const missing = group('missing', missingText[1]);
  const steps = document.createElement('ol');
  for (const text of missingText.slice(2, 5)) {
    const step = document.createElement('li');
    step.textContent = text;
    steps.append(step);
  }
  missing.append(steps);
  field(missing, 'other-dispatch', missingText[5], 'select', 'Weitere Versandbestaetigung', [['yes',missingText[6]],['no',missingText[7]],['unchecked',missingText[8]]]).required = false;
  field(missing, 'packing-check', missingText[9], 'select', 'Packzettel geprueft', [['yes',missingText[10]],['no',missingText[11]],['none',missingText[12]]]).required = false;
  field(missing, 'other-tracking', missingText[13], 'text', 'Weitere Trackingnummer');
  const technicalCopy = {
  "de": [
    "Ich komme im Shop nicht weiter",
    "Beschreibe unten, was du tun wolltest und was stattdessen passiert. Wir prüfen das Problem anhand deiner Angaben.",
    "Technisches Problem im Shop",
    "Welcher Bereich ist betroffen?",
    "Warenkorb / Kaufabschluss",
    "Rabattcode",
    "Wishlist",
    "Verfügbarkeitsbenachrichtigung",
    "Anderer Bereich",
    "Welches Gerät nutzt du? (optional)",
    "Handy",
    "Tablet",
    "Computer",
    "Browser und Version (falls bekannt)",
    "Betroffene Seite (optional)",
    "Fehlermeldung (falls angezeigt)",
    "Was wolltest du tun und was passiert stattdessen?",
    "Screenshot per E-Mail senden",
    "Öffnet dein E-Mail-Programm mit deinen bisherigen Angaben. Hänge dort den Screenshot an und sende die Nachricht. Du brauchst das Formular dann nicht zusätzlich zu senden.",
    "Technisches Problem im Monolith Shop"
  ],
  "en": [
    "I am stuck in the shop",
    "Tell us below what you wanted to do and what happened instead. We will investigate using your information.",
    "Technical problem in the shop",
    "Which area is affected?",
    "Cart / checkout",
    "Discount code",
    "Wishlist",
    "Back-in-stock notification",
    "Another area",
    "Which device are you using? (optional)",
    "Phone",
    "Tablet",
    "Computer",
    "Browser and version (if known)",
    "Affected page (optional)",
    "Error message (if shown)",
    "What were you trying to do and what happened instead?",
    "Send a screenshot by email",
    "Opens your email app with the information entered so far. Attach the screenshot there and send your message. You do not need to send the form as well.",
    "Technical problem in the Monolith Shop"
  ],
  "fr": [
    "Je suis bloqué dans la boutique",
    "Décrivez ci-dessous ce que vous vouliez faire et ce qui s’est passé. Nous examinerons le problème avec ces informations.",
    "Problème technique dans la boutique",
    "Quelle partie est concernée ?",
    "Panier / paiement",
    "Code de réduction",
    "Liste de souhaits",
    "Alerte de retour en stock",
    "Autre partie",
    "Quel appareil utilisez-vous ? (facultatif)",
    "Téléphone",
    "Tablette",
    "Ordinateur",
    "Navigateur et version (si connus)",
    "Page concernée (facultatif)",
    "Message d’erreur (si affiché)",
    "Que vouliez-vous faire et que s’est-il passé ?",
    "Envoyer une capture par e-mail",
    "Ouvre votre messagerie avec les informations saisies. Joignez la capture puis envoyez votre message. Il est inutile d’envoyer aussi le formulaire.",
    "Problème technique dans la boutique Monolith"
  ],
  "it": [
    "Non riesco a proseguire nel negozio",
    "Descrivi sotto cosa volevi fare e cosa è successo. Verificheremo il problema con queste informazioni.",
    "Problema tecnico nel negozio",
    "Quale area è interessata?",
    "Carrello / checkout",
    "Codice sconto",
    "Lista desideri",
    "Avviso di disponibilità",
    "Altra area",
    "Quale dispositivo usi? (facoltativo)",
    "Telefono",
    "Tablet",
    "Computer",
    "Browser e versione (se noti)",
    "Pagina interessata (facoltativo)",
    "Messaggio di errore (se presente)",
    "Cosa volevi fare e cosa è successo invece?",
    "Invia uno screenshot via email",
    "Apre la tua app email con le informazioni inserite. Allega lo screenshot e invia il messaggio. Non serve inviare anche il modulo.",
    "Problema tecnico nel Monolith Shop"
  ],
  "es": [
    "No puedo continuar en la tienda",
    "Describe abajo qué querías hacer y qué ocurrió. Revisaremos el problema con tus datos.",
    "Problema técnico en la tienda",
    "¿Qué área está afectada?",
    "Carrito / finalizar compra",
    "Código de descuento",
    "Lista de deseos",
    "Aviso de disponibilidad",
    "Otra área",
    "¿Qué dispositivo usas? (opcional)",
    "Teléfono",
    "Tableta",
    "Ordenador",
    "Navegador y versión (si los sabes)",
    "Página afectada (opcional)",
    "Mensaje de error (si aparece)",
    "¿Qué querías hacer y qué ocurrió en su lugar?",
    "Enviar captura por correo",
    "Abre tu app de correo con los datos introducidos. Adjunta la captura y envía el mensaje. No necesitas enviar también el formulario.",
    "Problema técnico en Monolith Shop"
  ],
  "pl": [
    "Nie mogę kontynuować w sklepie",
    "Opisz poniżej, co chcesz zrobić i co dzieje się zamiast tego. Sprawdzimy problem na podstawie tych informacji.",
    "Problem techniczny w sklepie",
    "Którego obszaru dotyczy problem?",
    "Koszyk / finalizacja zakupu",
    "Kod rabatowy",
    "Lista życzeń",
    "Powiadomienie o dostępności",
    "Inny obszar",
    "Jakiego urządzenia używasz? (opcjonalnie)",
    "Telefon",
    "Tablet",
    "Komputer",
    "Przeglądarka i wersja (jeśli znane)",
    "Strona z problemem (opcjonalnie)",
    "Komunikat błędu (jeśli jest)",
    "Co chcesz zrobić i co dzieje się zamiast tego?",
    "Wyślij zrzut ekranu e-mailem",
    "Otwiera pocztę z wpisanymi danymi. Dołącz zrzut ekranu i wyślij wiadomość. Nie musisz wysyłać również formularza.",
    "Problem techniczny w Monolith Shop"
  ],
  "sv": [
    "Jag kommer inte vidare i butiken",
    "Beskriv nedan vad du ville göra och vad som hände i stället. Vi undersöker problemet med dina uppgifter.",
    "Tekniskt problem i butiken",
    "Vilket område gäller det?",
    "Varukorg / kassa",
    "Rabattkod",
    "Önskelista",
    "Lageravisering",
    "Annat område",
    "Vilken enhet använder du? (valfritt)",
    "Telefon",
    "Surfplatta",
    "Dator",
    "Webbläsare och version (om känt)",
    "Berörd sida (valfritt)",
    "Felmeddelande (om det visas)",
    "Vad ville du göra och vad hände i stället?",
    "Skicka skärmbild via e-post",
    "Öppnar din e-postapp med uppgifterna du fyllt i. Bifoga skärmbilden och skicka meddelandet. Du behöver inte skicka formuläret också.",
    "Tekniskt problem i Monolith Shop"
  ],
  "fi": [
    "En pääse eteenpäin kaupassa",
    "Kerro alla, mitä yritit tehdä ja mitä tapahtui sen sijaan. Selvitämme ongelmaa antamiesi tietojen avulla.",
    "Tekninen ongelma kaupassa",
    "Mitä aluetta ongelma koskee?",
    "Ostoskori / kassa",
    "Alennuskoodi",
    "Toivelista",
    "Saatavuusilmoitus",
    "Muu alue",
    "Mitä laitetta käytät? (valinnainen)",
    "Puhelin",
    "Tabletti",
    "Tietokone",
    "Selain ja versio (jos tiedossa)",
    "Ongelmasivu (valinnainen)",
    "Virheilmoitus (jos näkyvissä)",
    "Mitä yritit tehdä ja mitä tapahtui sen sijaan?",
    "Lähetä kuvakaappaus sähköpostilla",
    "Avaa sähköpostisovelluksen syöttämilläsi tiedoilla. Liitä kuvakaappaus ja lähetä viesti. Lomaketta ei tarvitse lähettää lisäksi.",
    "Tekninen ongelma Monolith Shopissa"
  ],
  "nl": [
    "Ik kom niet verder in de winkel",
    "Beschrijf hieronder wat je wilde doen en wat er in plaats daarvan gebeurde. We onderzoeken het met jouw informatie.",
    "Technisch probleem in de winkel",
    "Welk onderdeel is getroffen?",
    "Winkelwagen / afrekenen",
    "Kortingscode",
    "Verlanglijst",
    "Voorraadmelding",
    "Ander onderdeel",
    "Welk apparaat gebruik je? (optioneel)",
    "Telefoon",
    "Tablet",
    "Computer",
    "Browser en versie (indien bekend)",
    "Betrokken pagina (optioneel)",
    "Foutmelding (indien getoond)",
    "Wat wilde je doen en wat gebeurde er in plaats daarvan?",
    "Screenshot per e-mail sturen",
    "Opent je e-mailapp met de ingevulde gegevens. Voeg de screenshot toe en verstuur je bericht. Je hoeft het formulier dan niet ook te versturen.",
    "Technisch probleem in de Monolith Shop"
  ]
};
  const technicalText = technicalCopy[locale] || technicalCopy.en;
  const technical = group('technical', technicalText[2]);
  const productLabels = {"de": "Produkt und Variante", "en": "Product and variant", "fr": "Produit et variante", "it": "Prodotto e variante", "es": "Producto y variante", "pl": "Produkt i wariant", "sv": "Produkt och variant", "fi": "Tuote ja vaihtoehto", "nl": "Product en variant"};
  const technicalProduct = field(technical, 'technical-product', productLabels[locale] || productLabels.en, 'text', 'Produkt und Variante');
  technicalProduct.maxLength = 500;
  field(technical, 'technical-area', technicalText[3], 'select', 'Technischer Bereich', [['cart',technicalText[4]],['discount',technicalText[5]],['wishlist',technicalText[6]],['restock',technicalText[7]],['other',technicalText[8]]]);
  field(technical, 'technical-device', technicalText[9], 'select', 'Geraet', [['phone',technicalText[10]],['tablet',technicalText[11]],['computer',technicalText[12]]]).required = false;
  field(technical, 'technical-browser', technicalText[13], 'text', 'Browser und Version');
  const page = field(technical, 'technical-page', technicalText[14], 'url', 'Betroffene Seite');
  page.maxLength = 500;
  page.value = (location.origin + location.pathname).slice(0, 500);
  field(technical, 'technical-error', technicalText[15], 'text', 'Technische Fehlermeldung');
  const screenshot = document.createElement('a');
  screenshot.className = 'mono-advisors__application-link';
  screenshot.dataset.advisorTechnicalScreenshot = '';
  screenshot.textContent = technicalText[17];
  const screenshotHint = document.createElement('p');
  screenshotHint.className = 'mono-advisors__note';
  screenshotHint.textContent = technicalText[18];
  technical.append(screenshot, screenshotHint);
  const form = root.querySelector('form');
  const messageLabel = root.querySelector('label[for="monolith-advisor-message"]');
  const defaultMessageLabel = messageLabel.textContent;
  const updateScreenshot = () => {
    const rows = [technicalText[2]];
    for (const input of form.querySelectorAll('input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)')) {
      if (!input.value || input.closest('[hidden]') || input.type === 'file' || input.type === 'checkbox') continue;
      const label = root.querySelector(`label[for="${input.id}"]`)?.textContent;
      if (label) rows.push(label + ': ' + (input.tagName === 'SELECT' ? input.selectedOptions[0].textContent : input.value));
    }
    screenshot.href = 'mailto:info@monolith-shop.eu?subject=' + encodeURIComponent(technicalText[19]) + '&body=' + encodeURIComponent(rows.join('\r\n\r\n'));
  };
  form.addEventListener('input', updateScreenshot);
  form.addEventListener('change', updateScreenshot);
  screenshot.addEventListener('click', updateScreenshot);
  updateScreenshot();
  root.addEventListener('monolith:case-change', () => {
    const active = root.querySelector('[data-advisor-photos]').dataset.case;
    for (const [key, fieldset] of Object.entries(groups)) {
      fieldset.hidden = key !== active;
      fieldset.disabled = key !== active;
    }
    if (active === 'change') updateChange();
    messageLabel.textContent = active === 'technical' ? technicalText[16] : defaultMessageLabel;
    if (active === 'technical') updateScreenshot();
  });
})();

